import { render } from "./PostbackNoteDialog.vue?vue&type=template&id=9fb2a788&ts=true"
import script from "./PostbackNoteDialog.vue?vue&type=script&lang=ts"
export * from "./PostbackNoteDialog.vue?vue&type=script&lang=ts"

import exportComponent from "/home/app/mt-partners/frontend/affiliate/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QCardSection,QBtn,QCardActions});
